import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

/**
 * Guard that prevents authenticated users from accessing public-only routes
 * like login and registration pages. Redirects authenticated users to root.
 */
export const publicOnlyGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Allow the in-flight sign-out navigation to land on /login even though
  // the user signal is briefly still authenticated — otherwise the guard
  // bounces the logout back to the dashboard.
  if (authService.isAuthenticated() && !authService.isSigningOut()) {
    return router.createUrlTree(['/']);
  }

  // User is not authenticated (or signing out), allow access to public route
  return true;
};
